import React from 'react';
import cx from 'classnames';

import Button from '../../atoms/Button';
import Icon from '../../atoms/Icon';
import Text from '../../atoms/Text';

import styles from './Dropzone.module.scss';
import usePresenter from './Dropzone.presenter';
import getProps from './Dropzone.props';
import { DropzoneCombinedProps } from './types';


const Dropzone: React.FC<DropzoneCombinedProps> = (props) => {
  const {
    state,
    error,
    className,
    classes,
    icon,
    text,
    icon1,
    instructions,
    oR,
    button,
    getRootProps,
    getInputProps,
  } = usePresenter(props);

  const variantName = `${state}${error}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`dropzone${variantName}`];


  let componentView;

  switch (variantName) {
    case 'DefaultError':
    case 'DefaultNone':
    case 'DraggingError':
    case 'DraggingNone': {
      let inputView;
      if (getInputProps) {
        inputView = (
          <input {...getInputProps()} />
        );
      }
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.errorLine, classes?.errorLine)}>
            <Icon
              className={cx(styles.icon, classes?.icon)}
              {...internalProps.icon}
              {...icon}/>
            <Text
              className={cx(styles.text, classes?.text)}
              {...internalProps.text}
              {...text}/>
          </div>
          <div className={cx(styles.dropzone, classes?.dropzone)}
            {...(getRootProps ? getRootProps() : {})}
          >
            <Icon
              className={cx(styles.icon1, classes?.icon1)}
              {...internalProps.icon1}
              {...icon1}/>
            <div className={cx(styles.bottomContent, classes?.bottomContent)}>
              <Text
                className={cx(styles.instructions, classes?.instructions)}
                {...internalProps.instructions}
                {...instructions}/>
              <Text
                className={cx(styles.oR, classes?.oR)}
                {...internalProps.oR}
                {...oR}/>
              <Button
                className={cx(styles.button, classes?.button)}
                {...internalProps.button}
                {...button}/>
            </div>
            {inputView}
          </div>
        </div>
      );
      break;
    }
    case 'LoadingNone': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <div className={cx(styles.errorLine, classes?.errorLine)}/>
          <div className={cx(styles.dropzone, classes?.dropzone)}>
            <Icon
              className={cx(styles.icon, classes?.icon)}
              {...internalProps.icon}
              {...icon}/>
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default Dropzone;
